import Button from "components/shared/button";
import { Text } from "components/shared/text";

export const TitleRow: React.FC<{
  title: string;
  itemCount: number;
  isExpanded: boolean;
  toggle: () => void;
}> = ({ title, itemCount, isExpanded, toggle }) => {
  return (
    <group data-name="grid_header">
      <group data-wrap="no" data-sticky-row="">
        <group
          data-length="380"
          data-align="center"
          data-gap="10"
          data-space-left="10"
          data-background="grey-color-light"
          data-border-left=""
          data-border-vertical="1"
          data-sticky="left"
        >
          <Button
            data-color="grey-color-mid"
            micro
            rounded
            icon="expand_more"
            className={isExpanded ? "" : "rotate"}
            onClick={() => toggle()}
          />
          <Text data-weight="500" data-color="grey-color-mid">
            {title}
          </Text>
        </group>
        {[...Array(itemCount)].map((_col, i) => (
          <TitleRowBlock key={i} lastItem={i === itemCount - 1} />
        ))}
      </group>
    </group>
  );
};

const TitleRowBlock: React.FC<{ lastItem?: boolean }> = ({ lastItem }) => (
  <group
    data-border-vertical="1"
    data-background="grey-color-light"
    data-length="260"
    data-height="40"
    data-space-horizontal="10"
    data-align="center"
    {...(lastItem ? { "data-border-right": "" } : null)}
  ></group>
);
